module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editReservationPopupBg",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.pressDone.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "popupArea bg-lightest px-3 overflow-auto"
  }, [_c('div', {
    staticClass: "text-center fs-larger font-weight-600 p-3"
  }, [_vm._v("\n            Edit Extras\n        ")]), _vm._v(" "), _c('extras-manager', {
    staticClass: "extrasHolder",
    attrs: {
      "readOnly": false,
      "allowChangeUnsaved": true,
      "reservation": _vm.getSelectedReservation,
      "extrasArrayImported": _vm.copyOfExtras
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-2 mb-3 d-flex justify-content-end align-items-center"
  }, [_c('button', {
    staticClass: "btn primary wider ml-2",
    on: {
      "click": _vm.pressDone
    }
  }, [_vm._v("Done")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-23248ca4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23248ca4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/ViewExtras.vue
// module id = 1923
// module chunks = 0